export default {
  'delegatedTasks.title': 'Delegated tasks',
  'delegatedTasks.toolbarTitle': 'Tasks',
  'delegatedTasks.description': 'View the tasks associated with this delegation configuration.',

  'delegatedTasks.form.status': 'Status',
  'delegatedTasks.form.process': 'Process',
  'delegatedTasks.form.environment': 'Environment',
  'delegatedTasks.form.processInstanceName': 'Request Name',
  'delegatedTasks.form.name': 'Delegated User',
  'delegatedTasks.form.actionInstanceId': 'Execution Step',
  'delegatedTasks.form.created': 'Creation Date',

  'delegatedTasks.delegated': 'Delegated',
  'delegatedTasks.deleted': 'Removed',
};
